import React from "react";
const StrategyManageContext = React.createContext();
export default StrategyManageContext;